import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import type { VATDefinition } from 'Services/ProductManagement/Features/VATDefinition/types'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography
} from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface VATDefinitionDetailsProps {
  vatDefinition: VATDefinition
}

export default function VATDefinitionDetails({
  vatDefinition
}: Readonly<VATDefinitionDetailsProps>) {
  const vatPercentages = vatDefinition.vat_percentages.map(
    vatPercentage => `${vatPercentage.vat_code} (${vatPercentage.vat_percent} %)`
  )

  const vatPercentagesToDisplay = vatPercentages.length > 0 ? vatPercentages.join(', ') : '-'

  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Title`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(vatDefinition.title)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(vatDefinition.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`VAT percentages`}</StyledTableCell>
            <TableCell>
              <Typography variant="body2">{vatPercentagesToDisplay}</Typography>
            </TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Description`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(vatDefinition.description)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(vatDefinition.modified_timestamp)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
